<template>
  <base-show :fields="fields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs"
             :disableEdit="isProvider && !permissionArticleEdit">
    <template v-slot:actions.remove>
      <span v-if="authAccountId === pk" />
    </template>
    <template slot="for_paid_user" slot-scope="{ input }">
      <span style="font-weight: 600;">
        {{input === 1 ? "有料会員向け" :
            ( input === 0 ? "全会員向け" : "")}}
      </span>
    </template>
  </base-show>
</template>

<script>
export default {
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    const vm = this;
    return {
      resourceName: "topics",
      fields: [
        [
          {
            label: "特集ページ名",
            name: "title",
            long: true
          },
          {
            label: "特集ページURL",
            name: "url",
            long: true
          },
          {
            label: "特集ページサムネイル画像",
            name: "images",
            type: "images",
            long: true
          },
          {
            label: "メーカー名",
            name: "Article_name",
            long: true
          },
          {
            label: "ジャンル",
            name: "genre",
            long: true
          },
          {
            label: "公開期間 from",
            name: "publish_from",
            long: true
          },
          {
            label: "公開期間 to",
            name: "publish_to",
            long: true
          },
          {
            label: "有料会員向けフラグ",
            name: "for_paid_user",
            type: "custom",
            long: true
          },
          {
            label: "公開/非公開",
            name: "published",
            optionType: "common/publish",
            render(value) {
              return vm.optionName("common/publish", value);
            }
          }
        ]
      ]
    };
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "特集ページ一覧",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "特集ページ詳細",
          disabled: true
        }
      ];
    },
    authAccountId() {
      return this.$store.getters[`auth/accountId`];
    },
    optionName() {
      return (optionName, value) => {
        const options =
          this.$store.getters[`${optionName}/options/options`] || [];
        return (options.find(v => v.value === value) || {}).label;
      };
    },
    permissionArticleEdit() {
      return this.$store.getters[`auth/permissionArticleEdit`];
    },
    isProvider() {
      return this.$store.getters[`auth/isProvider`];
    }
  }
};
</script>
